// openBaseSettings.js — cross-component event to open Base Settings

const OPEN_BASE_SETTINGS_EVENT = 'orbital:open-base-settings';

/**
 * Requests that the base settings modal open.
 * Fire-and-forget; the switcher toggle listens and opens the modal.
 *
 * @param {string|object|null} [tabOrOptions] - Optional tab key (`'about'`,
 *   `'purchase-orders'`, …), or `{ tab }`.
 */
export function openBaseSettings(tabOrOptions = null) {
  if (typeof window === 'undefined') return;

  let tab = '';
  if (typeof tabOrOptions === 'string') {
    tab = tabOrOptions.trim();
  } else if (tabOrOptions && typeof tabOrOptions === 'object') {
    tab = String(tabOrOptions.tab || '').trim();
  }

  window.dispatchEvent(new CustomEvent(OPEN_BASE_SETTINGS_EVENT, {
    detail: {
      ...(tab ? { tab } : {}),
    },
  }));
}

/**
 * Subscribes to open-settings requests.
 *
 * @param {Function} handler - Receives event detail (`{ tab? }`).
 * @returns {Function} unsubscribe
 */
export function subscribeOpenBaseSettings(handler) {
  if (typeof window === 'undefined' || typeof handler !== 'function') {
    return () => {};
  }

  const listener = (event) => {
    handler(event?.detail || {});
  };

  window.addEventListener(OPEN_BASE_SETTINGS_EVENT, listener);
  return () => {
    window.removeEventListener(OPEN_BASE_SETTINGS_EVENT, listener);
  };
}
